import { AnalyticsType, TStoreSeachViewType } from "./model";

export const searchLocationsPayload = (
  keyword: string,
  auto_suggest_word: string,
  view_type: TStoreSeachViewType
): AnalyticsType => ({ keyword, auto_suggest_word, view_type });
